// extracted by mini-css-extract-plugin
export default {"container":"A9rWvDFTvbx80YpjzCBe"};